<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">

</script>

<style>
html,body{
    width: 100%;
    height: 100%;
    background: #fff;
    overflow: hidden;
}
#app{
  height: 100%;
}
</style>



